// AppsFlyer SDK Configuration
export const APPSFLYER_CONFIG = {
  devKey: 'CqgGnjhtF5oBcQKt7f7RBk',
  // iOS App Store ID must be numeric only (no "id" prefix)
  appId: '6757657079',
  isDebug: false, // Set to true for development/testing
  waitForATTUserAuthorization: 10, // seconds to wait for ATT dialog on iOS
} as const;
